import { Label } from '@radix-ui/react-select';
import React from 'react';

import { cn } from '@/services/utils';

/**
 * Used to render the label of a group. It won't be focusable using arrow keys.
 */
const SelectLabel = React.forwardRef<
    React.ElementRef<typeof Label>,
    React.ComponentPropsWithoutRef<typeof Label>
>(({ className, ...props }, ref) => (
    <Label
        ref={ref}
        className={cn(
            'tw-py-1.5 tw-pl-8 tw-pr-2 tw-text-t-sm tw-font-bold',
            className,
        )}
        {...props}
    />
));

SelectLabel.displayName = Label.displayName;

export { SelectLabel };
